// src/pages/contactus.jsx
import React from 'react';
import Head from '../components/head';
const ContactUs = () => (
<main>
<Head
title="Contact Us - ITS Projects Pty Ltd"
/>
	<section id="main" className="wrapper style2 contact-main">
		<div className="title">
		<h1 className="page-title">Contact Us</h1>
		<nav aria-label="breadcrumb" className="breadcrumb-container">
			<ol className="breadcrumb slim-breadcrumb">
				<li className="breadcrumb-item"><a href="/"><i className="fas fa-home"></i> ITS</a></li>
				<li className="breadcrumb-item active" aria-current="page"><i className="fas fa-headset"></i> Contact Us</li>
			</ol>
		</nav>
		</div>
		<div className="container">
		
		
		<header className="style1">
		<h2>We’re here to connect with you!</h2>
		<p>Whether it’s in person, by phone, or email, reach out anytime. We’re committed to responding promptly and look forward to assisting you.</p>
		</header>
		
		<div className="row">   
			<div className="col-12 col-12-medium">
					<section className="feature-list large">
						<div className="row">
							<div className="col-6 col-12-small">
								<section>
									<h3 className="icon solid fa-home">Warehouse</h3>
									<p>
									2/26 Sterling Rd,<br />
									Minchibury, NSW, 2770
									</p>
								</section>
							</div>
							<div className="col-6 col-12-small">
								<section>
									<h3 className="icon solid fa-clock">Pick Up Hours</h3>
									<ul>
										<li>Monday - Friday: 8:00 AM - 5:00 PM</li>
										<li>Saturday: 9:00 AM - 4:00 PM</li>
										<li>Sunday & Public holiday: Closed</li>
									</ul>
								</section>
							</div>
							<div className="col-6 col-12-small">
								<section>
									<h3 className="icon solid fa-envelope">Email</h3>
									<ul>
									<li><a href="mailto:info@itstiles.com.au">info@itstiles.com.au</a></li>
									</ul>
									<p>
										
									</p>
								</section>
							</div>
							<div className="col-6 col-12-small">
								<section>
									<h3 className="icon solid fa-phone">Phone</h3>
									<ul>
									<li>0413 577 933</li>
									</ul>
									<p>
									
									</p>
								</section>
							</div>
						</div>
					</section>

			</div>
		</div>
		</div>
	</section>
	
</main>
);

export default ContactUs;